import SectionHeader from "@/components/SectionHeader";
import { Shield, Users, Trophy, Zap } from "lucide-react";

const STORY = [
  { year: "2022", title: "The Beginning", body: "A small Discord of Indian Minecraft players started a private SMP after Season 1 of a lifesteal event went viral in the community." },
  { year: "2023", title: "First Public Season", body: "Season 3 launched publicly. 5,000 members joined the Discord in the first two weeks." },
  { year: "2024", title: "Network Expansion", body: "Added Creative and Events servers. First large PvP tournament with 128 players." },
  { year: "2025", title: "Community First", body: "Introduced player-run towns, custom quests, DC Coins economy and monthly festivals." },
  { year: "2026", title: "Season 8", body: "Biggest season yet — new spawn, custom mechanics and a battle pass built with community feedback." },
];

const PILLARS = [
  { icon: Shield, title: "Fair Play", body: "Zero tolerance for hacks. Active moderation, transparent bans, no pay-to-win." },
  { icon: Users, title: "Community First", body: "Every big change goes through community polls. Your voice shapes the network." },
  { icon: Trophy, title: "Competitive Spirit", body: "Weekly events, tournaments and leaderboards keep the grind exciting." },
  { icon: Zap, title: "Always Improving", body: "Custom plugins, weekly patches, and a team that actually plays alongside you." },
];

export default function About() {
  return (
    <div className="pt-32 pb-24 px-4 sm:px-6" data-testid="page-about">
      <div className="max-w-5xl mx-auto">
        <SectionHeader eyebrow="About" title="Built By The Community" subtitle="LostDC Network is more than a server — it's a family of players, builders and competitors from across India." />

        <div className="grid md:grid-cols-2 gap-4 mb-16">
          {PILLARS.map((p) => (
            <div key={p.title} className="rounded-2xl glass p-6 hover-lift">
              <div className="w-10 h-10 rounded-md bg-[#FFBF00]/15 grid place-items-center text-[#FFBF00] mb-3">
                <p.icon size={18} />
              </div>
              <div className="font-hero text-2xl">{p.title}</div>
              <p className="text-sm text-white/60 mt-2">{p.body}</p>
            </div>
          ))}
        </div>

        <div className="text-[11px] uppercase tracking-[0.4em] text-[#FFBF00] mb-4">Our Story</div>
        <div className="relative pl-6 border-l border-white/10 space-y-8">
          {STORY.map((s) => (
            <div key={s.year} className="relative" data-testid={`about-story-${s.year}`}>
              <div className="absolute -left-[31px] top-1 w-3 h-3 rounded-full bg-[#FFBF00] shadow-[0_0_16px_rgba(255,191,0,0.6)]" />
              <div className="font-mono text-xs text-[#FFBF00]/80">{s.year}</div>
              <div className="font-hero text-2xl mt-1">{s.title}</div>
              <p className="text-sm text-white/60 mt-1 max-w-2xl">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
